import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import LoginPage from '../feature/pages/Other Pages/LoginPage';
import DefaultLayout from '../layout/DefaultLayout';
import DashboardPage from '../feature/pages/Dashboard Pages/DashboardPage';
import ReportsPage from '../feature/pages/Reports Page/ReportsPage';
import ProfilePage from '../feature/pages/Profile Pages/ProfilePage';
import IndividualExperiencePage from '../feature/pages/Experience Pages/Guest/IndividualExperiencePage';
import ReservationRequestPage from '../feature/pages/Reservation Pages/ReservationRequestPage';
import ReservationPage from '../feature/pages/Reservation Pages/ReservationPage';
import RsvpRequestsPage from '../feature/pages/Reservation Pages/RsvpRequestsPage';
import UsersPage from '../feature/pages/User Pages/UsersPage';
import OwnerExperiencesPage from '../feature/pages/Experience Pages/Owner/OwnerExperiencesPage';
import ErrorPage from '../feature/pages/ErrorPage';
import ViewAllExperiencesPage from '../feature/pages/Experience Pages/Guest/ViewAllExperiencesPage';
import ViewOwnersExperiencesPage from '../feature/pages/Experience Pages/Owner/ViewOwnersExperiencesPage';
import OwnersIndividualExperiencePage from '../feature/pages/Experience Pages/Owner/OwnersIndividualExperiencePage';
import ClientListPage from '../feature/pages/Client Pages/ClientListPage';
import UserFormPage from '../feature/pages/User Pages/UserFormPage';
import ClientFormPage from '../feature/pages/Client Pages/ClientFormPage';
import ResetPasswordPage from '../feature/pages/Other Pages/ResetPasswordPage';
import PermissionDeniedPage from '../feature/pages/PermissionDenied';
import IndividualReportPage from '../feature/pages/Reports Page/IndividualReportPage';
import DashboardReportPage from '../feature/pages/Dashboard Pages/DashboardReportPage';
import HelpPage from '../feature/pages/Other Pages/HelpPage';
import GuestListPage from '../feature/pages/Guest Pages/GuestListPage';
import IndividualGuestPage from '../feature/pages/Guest Pages/IndividualGuestPage';
import GuestProfilePage from '../feature/pages/Guest Pages/GuestProfilePage';
import GuestUserProfilePage from '../feature/pages/Guest Pages/GuestUserProfilePage';
import ViewIndividualUser from '../feature/components/User Management/ViewIndividualUser';
import RequireAuth from '../feature/pages/Auth/RequireAuth';
import HomeRedirect from '../feature/pages/Auth/HomeRedirect';
import FeesPage from '../feature/pages/Fees Page/FeesPage';
import AddFeePage from '../feature/pages/Fees Page/AddFeePage';
import EditFeePage from '../feature/pages/Fees Page/EditFeePage';
import VerifyEmailPage from '../feature/pages/Other Pages/VerifyEmailPage';
import BookingCapPage from '../feature/pages/Booking Caps Page/BookingCapPage';
import AddBookingCapPage from '../feature/pages/Booking Caps Page/AddBookingCapPage';
import EditBookingCapPage from '../feature/pages/Booking Caps Page/EditBookingCapPage';
import PoliciesPage from '../feature/pages/Policy Page/PoliciesPage';
import AddPolicyPage from '../feature/pages/Policy Page/AddPolicyPage';
import EditPolicyPage from '../feature/pages/Policy Page/EditPolicyPage';
import TeamsListPage from '../feature/pages/Teams Page/TeamsListPage';
import AddTeamsPage from '../feature/pages/Teams Page/AddTeamsPage';
import EditTeamsPage from '../feature/pages/Teams Page/EditTeamsPage';
import AiAssistantReservationsPage from '../feature/pages/Reservation Pages/AiAssistantReservationsPage';
import ManageAppFee from '../feature/pages/7DAY Admin Pages/App Fees/ManageAppFee';
import ReleaseNotesSettingsPage from '../feature/pages/7DAY Admin Pages/ReleaseNotes/ReleaseNotesSettingsPage';
import Messages from '../feature/pages/Messaging Pages/Messages';
import MessagingSettingsPage from '../feature/pages/Messaging Pages/MessagingSettingsPage';
import Billing from '../feature/pages/Billing Pages/Billing';
import IndividualBillPage from '../feature/pages/Billing Pages/IndividualBillPage';
import { BillsAndInvoicesPage } from '../feature/pages/7DAY Admin Pages/BillsAndInvoices/BillsAndInvoicesPage';
import { EarningsPage } from '../feature/pages/HostPaymentPages/EarningsPage';
import { HostPaymentPage } from '../feature/pages/HostPaymentPages/HostPaymentPage';
import ConnectToChat from '../feature/pages/Messaging Pages/ConnectToChat';
import ContractorListPage from '../feature/pages/Contractor Pages/ContractorListPage';
import NotificationsPage from '../feature/pages/Notifications Page/NotificationsPage';
import { ExpenseClaimsPage } from '../feature/pages/HostPaymentPages/ExpenseClaimsPage';
import AdminCentrePage from '../feature/pages/Admin Centre Page/AdminCentrePage';
import ContractorClients from '../feature/pages/Contractor Pages/ContractorClients';
import ContractorJobs from '../feature/pages/Contractor Pages/ContractorJobs';
import RequireRole from '../feature/pages/Auth/RequireRole';
import {
    AdminRole,
    ContractorRole,
    GuestRole,
    OwnerRole,
} from '../feature/enums/users';
import NirovisionConnectionPage from '../feature/pages/Nirovision Pages/NirovisionConnectionPage';
import ContractorCalendar from '../feature/pages/Contractor Pages/ContractorCalendar';
import OccupancyReport from '../feature/pages/Dashboard Pages/OccupancyReport';
import ExperienceOccupancyReport from '../feature/pages/Dashboard Pages/ExperienceOccupancyReport';
import AiHistoryPage from '../feature/pages/AI History Page/AiHistoryPage';
import AiHistoryIndividualPage from '../feature/pages/AI History Page/AiHistoryIndividualPage';
import HostPayoutDetailsPage from '../feature/pages/HostPaymentPages/HostPayoutDetailsPage';
import UserAccessControlPage from '../feature/pages/User Pages/UserAccessControlPage';
import XeroNetworkKeyPage from '../feature/pages/Xero Network Key Pages/XeroNetworkKeyPage';
import BillingExclusionsPage from '../feature/pages/Billing Pages/BillingExclusionsPage';
import ScheduledMessagesPage from '../feature/pages/Messaging Pages/ScheduledMessagesPage';
import ContractorProfilePage from '../feature/pages/Contractor Pages/ContractorProfilePage';
import WaitListRequestPage from '../feature/pages/Reservation Pages/WaitListRequestPage';
import ContractorJobList from '../feature/pages/Contractor Pages/Owner/ContractorJobList';
import RecurringJobList from '../feature/pages/Contractor Pages/Owner/RecurringJobList';
import DailyVisitorsPage from '../feature/pages/Reservation Pages/DailyVisitorsPage';
import OwnerNotificationsPage from '../feature/pages/Notifications Page/OwnerNotificationsPage';
import UserAccessControlPricing from '../feature/components/User Management/Access Control/UserAccessControlPricing';
import UserAccessControlVIP from '../feature/components/User Management/Access Control/UserAccessControlVIP';
import PricingTemplates from '../feature/components/Contractors/PricingTemplates/PricingTemplates';
import CreditHoldsPage from '../feature/pages/CreditHoldPages/CreditHoldsPage';
import CheckoutReservations from '../feature/components/Dashboard/Dashboard Reports/CheckoutReservations';
import TotalReservations from '../feature/components/Dashboard/Dashboard Reports/TotalReservations';
import ScheduledJobs from '../feature/components/Dashboard/Dashboard Reports/ScheduledJobs';
import ViewReservationsFormPage from '../feature/pages/Reservation Pages/ViewReservationsFormPage';
import RegisterPage from '../feature/pages/Other Pages/RegisterPage';
import RegisterationConfirmation from '../feature/components/Register/RegisterationConfirmation';
import RsvpPage from '../feature/pages/Other Pages/RsvpPage';
import VehiclesPage from '../feature/pages/Vehicles Pages/VehiclesPage';
import { trackPageView } from '../app/Analytics';
import SetMenus from '../feature/components/SetMenus/SetMenus';
import ExperienceFormPage from '../feature/pages/Experience Pages/Owner/Forms/ExperienceFormPage';
import ReviewExperiencePage from '../feature/pages/Experience Pages/Owner/Forms/ReviewExperiencePage';
import ExperienceEditFormPage from '../feature/pages/Experience Pages/Owner/Forms/ExperienceEditFormPage';
import OwnerProfilePage from '../feature/pages/Profile Pages/OwnerProfilePage';

export const router = createBrowserRouter([
    // Public routes
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/',
        element: <HomeRedirect />,
    },
    {
        path: '/register',
        element: <RegisterPage />,
    },
    {
        path: '/thankyou',
        element: <RegisterationConfirmation />,
    },
    {
        path: '/resetPassword/:id',
        element: <ResetPasswordPage />,
    },
    {
        path: '/verifyEmail/:userId/:token',
        element: <VerifyEmailPage />,
    },
    {
        path: '/rsvp/:bookingId/:rsvpId',
        element: <RsvpPage />,
    },
    // Protected routes
    {
        element: <DefaultLayout />,
        children: [
            {
                element: <RequireAuth />,
                children: [
                    {
                        element: <ConnectToChat />,
                        children: [
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            AdminRole.Admin,
                                            OwnerRole.Admin,
                                            GuestRole.Admin,
                                            GuestRole.DepartmentAdmin,
                                            ContractorRole.Admin,
                                        ]}
                                    />
                                ),

                                // User management
                                children: [
                                    { path: '/users', element: <UsersPage /> },
                                    {
                                        path: '/newUser',
                                        element: <UserFormPage />,
                                    },
                                    {
                                        path: '/users/:id/:id',
                                        element: <ViewIndividualUser />,
                                    },
                                    {
                                        path: '/user/:id/:id',
                                        element: <ViewIndividualUser />,
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            AdminRole.Admin,
                                            GuestRole.Admin,
                                        ]}
                                    />
                                ),
                                children: [
                                    { path: '/billing', element: <Billing /> },
                                    {
                                        path: '/invoices/:id',
                                        element: <IndividualBillPage />,
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            OwnerRole.Admin,
                                            AdminRole.Admin,
                                        ]}
                                    />
                                ),
                                children: [
                                    {
                                        path: '/adminCentre/host',
                                        element: <AdminCentrePage />,
                                    },
                                    {
                                        path: '/host-payment/:ownerId/:year/:month',
                                        element: <HostPaymentPage />,
                                    },
                                ],
                            },
                            // Guest Admin Centre
                            {
                                element: (
                                    <RequireRole roles={[GuestRole.Admin]} />
                                ),
                                children: [
                                    {
                                        path: '/adminCentre/guest',
                                        element: <AdminCentrePage />,
                                    },
                                    {
                                        path: '/teams',
                                        element: <TeamsListPage />,
                                    },
                                    {
                                        path: '/newTeam',
                                        element: <AddTeamsPage />,
                                    },
                                    {
                                        path: '/team/:id/edit',
                                        element: <EditTeamsPage />,
                                    },

                                    {
                                        path: '/accessControl',
                                        element: <UserAccessControlPage />,
                                    },
                                    {
                                        path: '/accessControl/pricing',
                                        element: <UserAccessControlPricing />,
                                    },
                                    {
                                        path: '/accessControl/VIP',
                                        element: <UserAccessControlVIP />,
                                    },
                                ],
                            },

                            {
                                element: (
                                    <RequireRole roles={[OwnerRole.Admin]} />
                                ),
                                children: [
                                    //Experiences
                                    {
                                        path: '/experiences/new/:id',
                                        element: <ExperienceFormPage />,
                                    },
                                    {
                                        path: '/experiences/edit/:id',
                                        element: <ExperienceEditFormPage />,
                                    },
                                    {
                                        path: '/experiences/new/:id/review',
                                        element: <ReviewExperiencePage />,
                                    },
                                    //Owner Admin Centre
                                    {
                                        path: '/fees',
                                        element: <FeesPage />,
                                    },
                                    {
                                        path: '/fees',
                                        element: <FeesPage />,
                                    },
                                    {
                                        path: '/newFee',
                                        element: <AddFeePage />,
                                    },
                                    {
                                        path: '/fees/:id/edit',
                                        element: <EditFeePage />,
                                    },
                                    {
                                        path: '/policies',
                                        element: <PoliciesPage />,
                                    },
                                    {
                                        path: '/newPolicy',
                                        element: <AddPolicyPage />,
                                    },
                                    {
                                        path: '/policies/:id',
                                        element: <EditPolicyPage />,
                                    },
                                    {
                                        path: '/messaging',
                                        element: <MessagingSettingsPage />,
                                    },
                                    {
                                        path: '/expenseClaims',
                                        element: <ExpenseClaimsPage />,
                                    },
                                    {
                                        path: '/vehicles',
                                        element: <VehiclesPage />,
                                    },
                                    {
                                        path: '/set-menus',
                                        element: <SetMenus />,
                                    },
                                    {
                                        path: '/earnings',
                                        element: <EarningsPage />,
                                    },
                                    {
                                        path: '/payoutDetails',
                                        element: <HostPayoutDetailsPage />,
                                    },
                                    {
                                        path: '/billingExclusions',
                                        element: <BillingExclusionsPage />,
                                    },
                                    {
                                        path: '/contractors',
                                        element: <ContractorListPage />,
                                    },
                                    {
                                        path: '/jobList',
                                        element: <ContractorJobList />,
                                    },
                                    {
                                        path: '/recurringJobs',
                                        element: <RecurringJobList />,
                                    },
                                    {
                                        path: '/contractors/:id',
                                        element: <ContractorProfilePage />,
                                    },
                                    {
                                        path: '/nirovision',
                                        element: <NirovisionConnectionPage />,
                                    },
                                    {
                                        path: '/xeroNetworkKey',
                                        element: <XeroNetworkKeyPage />,
                                    },
                                    {
                                        path: '/messages/templates',
                                        element: <ScheduledMessagesPage />,
                                    },
                                    {
                                        path: '/adminCentre/notifications',
                                        element: <OwnerNotificationsPage />,
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            OwnerRole.Admin,
                                            GuestRole.Admin,
                                        ]}
                                    />
                                ),
                                children: [
                                    //Booking Caps
                                    {
                                        path: '/bookingCaps',
                                        element: <BookingCapPage />,
                                    },
                                    {
                                        path: '/newBookingCap',
                                        element: <AddBookingCapPage />,
                                    },
                                    {
                                        path: '/bookingCap/:id/edit',
                                        element: <EditBookingCapPage />,
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            ContractorRole.Admin,
                                            ContractorRole.User,
                                        ]}
                                    />
                                ),
                                children: [
                                    {
                                        path: '/jobs',
                                        element: <ContractorJobs />,
                                    },
                                    {
                                        path: '/contractorCalendar',
                                        element: <ContractorCalendar />,
                                    },
                                    {
                                        path: '/contractorProfile',
                                        element: (
                                            <ProfilePage
                                                contractorCompany={true}
                                            />
                                        ),
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[ContractorRole.Admin]}
                                    />
                                ),
                                children: [
                                    {
                                        path: '/contractorClients',
                                        element: <ContractorClients />,
                                    },
                                    {
                                        path: '/pricingTemplates',
                                        element: <PricingTemplates />,
                                    },
                                    {
                                        path: '/contractorProfile',
                                        element: (
                                            <ProfilePage
                                                contractorCompany={true}
                                            />
                                        ),
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole roles={[AdminRole.Admin]} />
                                ),
                                children: [
                                    //Clients
                                    {
                                        path: '/clients',
                                        element: <ClientListPage />,
                                    },
                                    {
                                        path: '/newclient',
                                        element: <ClientFormPage />,
                                    },
                                    {
                                        path: '/clients/:id/:id',
                                        element: <ClientFormPage />,
                                    },
                                    {
                                        path: '/editClient/:id/:id',
                                        element: <ClientFormPage />,
                                    },
                                    //Guests
                                    {
                                        path: '/guests',
                                        element: <GuestListPage />,
                                    },
                                    {
                                        path: '/guests/:id/users',
                                        element: <IndividualGuestPage />,
                                    },
                                    {
                                        path: '/7dayfees',
                                        element: <ManageAppFee />,
                                    },
                                    {
                                        path: '/release-notes',
                                        element: <ReleaseNotesSettingsPage />,
                                    },
                                    // Bills/Fees
                                    {
                                        path: '/bills-invoices',
                                        element: <BillsAndInvoicesPage />,
                                    },
                                    // ai-chats
                                    {
                                        path: '/ai-history',
                                        element: <AiHistoryPage />,
                                    },
                                    {
                                        path: '/ai-history/:id',
                                        element: <AiHistoryIndividualPage />,
                                    },
                                    {
                                        path: '/credit-holds',
                                        element: <CreditHoldsPage />,
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            OwnerRole.Admin,
                                            OwnerRole.User,
                                        ]}
                                    />
                                ),
                                children: [
                                    {
                                        path: '/reports/occupancy',
                                        element: <OccupancyReport />,
                                    },
                                    {
                                        path: '/reports/occupancy/:id',
                                        element: <ExperienceOccupancyReport />,
                                    },
                                    {
                                        path: '/reservations/people',
                                        element: <DailyVisitorsPage />,
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            OwnerRole.Admin,
                                            OwnerRole.User,
                                            GuestRole.Admin,
                                            GuestRole.DepartmentAdmin,
                                        ]}
                                    />
                                ),
                                children: [
                                    {
                                        path: '/guests/:id',
                                        element: <GuestProfilePage />,
                                    },
                                ],
                            },
                            {
                                element: (
                                    <RequireRole
                                        roles={[
                                            OwnerRole.Admin,
                                            OwnerRole.User,
                                            GuestRole.Admin,
                                            GuestRole.DepartmentAdmin,
                                            GuestRole.User,
                                        ]}
                                    />
                                ),
                                children: [
                                    {
                                        path: '/guest-users/:id',
                                        element: <GuestUserProfilePage />,
                                    },
                                ],
                            },
                            { path: '/messages/:id?', element: <Messages /> },
                            {
                                path: '/messaging',
                                element: <MessagingSettingsPage />,
                            },
                            {
                                path: '/permissionDenied',
                                element: <PermissionDeniedPage />,
                            },
                            {
                                path: '/experiences',
                                element: <OwnerExperiencesPage />,
                            },
                            {
                                path: '/viewExperiences/all',
                                element: <ViewAllExperiencesPage />,
                            },
                            {
                                path: '/viewExperiences/business',
                                element: <ViewAllExperiencesPage />,
                            },
                            {
                                path: '/viewExperiences/personal',
                                element: <ViewAllExperiencesPage />,
                            },
                            {
                                path: '/viewExperiences/all/:id',
                                element: <ViewOwnersExperiencesPage />,
                            },
                            {
                                path: '/viewExperiences/business/:id',
                                element: <ViewOwnersExperiencesPage />,
                            },
                            {
                                path: '/viewExperiences/personal/:id',
                                element: <ViewOwnersExperiencesPage />,
                            },
                            {
                                path: '/viewExperiences/:id/:id',
                                element: <IndividualExperiencePage />,
                            },
                            {
                                path: '/viewExperiences/:id/:id/:id',
                                element: <OwnersIndividualExperiencePage />,
                            },
                            {
                                path: '/experiences/reservationRequest/:type/:name/:moduleId',
                                element: <ReservationRequestPage />,
                            },
                            {
                                path: '/experiences/waitListRequest/:id/:id/:id',
                                element: <WaitListRequestPage />,
                            },
                            {
                                path: '/reservationRequest/submitted/:id',
                                element: <ViewReservationsFormPage />,
                            },
                            {
                                path: '/reservationRequest/submitted/ai-assistant/:id',
                                element: <ViewReservationsFormPage />,
                            },
                            {
                                path: '/reservations',
                                element: <ReservationPage />,
                            },
                            {
                                path: '/rsvpRequests',
                                element: <RsvpRequestsPage />,
                            },
                            {
                                path: '/reservations/ai-assistant',
                                element: <AiAssistantReservationsPage />,
                            },
                            {
                                path: '/reservations/ai-assistant/:id/',
                                element: <ViewReservationsFormPage />,
                            },
                            {
                                path: '/reservations/:id/:id',
                                element: <ViewReservationsFormPage />,
                            },
                            {
                                path: '/editReservation/:id/:id',
                                element: <ViewReservationsFormPage />,
                            },
                            { path: '/dashboard', element: <DashboardPage /> },
                            {
                                path: '/dashboard/new-bookings',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/expense-claimed',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/add-ons-booked',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/jobs-created',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/rsvps-sent',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/rsvps-responded',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/guests',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/guest-users',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/external-guest-attendees',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/guest-pending-bookings',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/scheduled/all',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/scheduled/current-week',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/scheduled/next-week',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/scheduled/today',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/scheduled/tomorrow',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/scheduled/current-month',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/completed/current-month',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/completed/current-year',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/user/user-pending-bookings',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/user/user-approved-bookings',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/user/user-completed-bookings',
                                element: <DashboardReportPage />,
                            },
                            {
                                path: '/dashboard/checkout',
                                element: <CheckoutReservations />,
                            },
                            {
                                path: '/dashboard/reservations',
                                element: <TotalReservations />,
                            },
                            {
                                path: '/dashboard/scheduled-jobs',
                                element: <ScheduledJobs />,
                            },
                            {
                                path: '/notificationSettings',
                                element: <NotificationsPage />,
                            },
                            {
                                path: '/profile',
                                element: (
                                    <ProfilePage contractorCompany={false} />
                                ),
                            },
                            { path: '/reports', element: <ReportsPage /> },
                            {
                                path: '/reports/topGuests',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/topBookers',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/topExperiences',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/guestDetails',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/guests/:id/users',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/bookerDetails',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/cancellationReport',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/declinedReport',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/reservationsReport',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/monthlyReport',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/quarterlyReport',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/ytdReport',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/fyReport',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/guestInvoices',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/hostPayments',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/reports/mailingLists',
                                element: <IndividualReportPage />,
                            },
                            {
                                path: '/profile',
                                element: (
                                    <ProfilePage contractorCompany={false} />
                                ),
                            },
                            {
                                path: '/hosts/:id',
                                element: <OwnerProfilePage />,
                            },
                            // { path: '/documentation', element: <HelpPage /> },
                            { path: '/support', element: <HelpPage /> },
                            { path: '/privacy', element: <HelpPage /> },
                            { path: '/terms', element: <HelpPage /> },
                            { path: '*', element: <ErrorPage /> },
                        ],
                    },
                ],
            },
        ],
    },
]);

let currentPath = window.location.pathname + window.location.search;

trackPageView(currentPath);

router.subscribe((state) => {
    const path = state.location.pathname + state.location.search;

    if (path !== currentPath) {
        currentPath = path;
        trackPageView(path);
    }
});
